import { Selectors as MediaSelectors } from '../reducers/content/media'
import {
    dashboard,
    fixtures,
    content,
    stores,
} from '../containers/Landing/LandingIconsWhite'
import WhiteSelfServe from '../components/NavBar/icons/Icon-Self-Serve-White.png'
import ACL from './ACL'
import Routes from './routes'

export default [
    {
        name: 'List',
        route: Routes['ESTATE:LIST'],
        img: stores,
        acls: [],
        roles: [],
    },
    {
        name: 'Content',
        route: Routes.CONTENT,
        img: fixtures,
        acls: [ACL.VIEW_CONTENT, ACL.VIEW_MEDIA, ACL.VIEW_LAYERS],
        roles: [],
        highlight: (state) =>
            !!MediaSelectors.mediaPendingApprovalCount(state) || !!MediaSelectors.mediaPendingPushCount(state) || !!MediaSelectors.mediaPendingTestCount(state),
        submenu: [
            {
                name: 'Channels',
                route: Routes.CONTENT,
                acls: [ACL.VIEW_CONTENT],
                roles: [],
            },
            {
                name: 'Media',
                route: Routes['CONTENT:MEDIA'],
                acls: [ACL.VIEW_MEDIA],
                img: content,
                roles: [],
                highlight: (state) =>
                    !!MediaSelectors.mediaPendingApprovalCount(state) ||
                    !!MediaSelectors.mediaPendingPushCount(state) ||
                    !!MediaSelectors.mediaPendingTestCount(state),
            },
        ],
    },
    {
        name: 'Self-Serve',
        route: Routes.SELF_SERVE,
        img: WhiteSelfServe,
        acls: [ACL.VIEW_SELF_SERVE],
        roles: [],
    },
    {
        name: 'Reports',
        route: Routes.REPORTING_DASHBOARDS,
        img: dashboard,
        acls: [],
        roles: [],
    },
]
